const COLORS = {
  green: "bg-green-500/20   text-green-600   border-green-500/30",
  emerald: "bg-emerald-500/20 text-emerald-600 border-emerald-500/30",
  blue: "bg-blue-500/20    text-blue-600    border-blue-500/30",
  orange: "bg-orange-500/20  text-orange-600  border-orange-500/30",
  red: "bg-red-500/20     text-red-600     border-red-500/30",
  yellow: "bg-yellow-500/20  text-yellow-600  border-yellow-500/30",
  purple: "bg-purple-500/20  text-purple-600  border-purple-500/30",
  neutral: "bg-surface-container-high text-on-surface-variant border-surface-container-high",
};

const Chip = ({ children, color = "neutral", className = "" }) => (
  <span
    className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold border ${COLORS[color]} ${className}`}
  >
    {children}
  </span>
);

export default Chip;
